import type { FaireProductEntity } from "../../entity_types/product";

export const p_2xcv6kgr4b: FaireProductEntity = {
  token: "p_2xcv6kgr4b",
  type: "product",
  name: "Mini Room Deodorant",
  brandToken: "b_8aa5kchc2z",
  brandName: "Homecourt",
  imageUrl:
    "https://cdn.faire.com/fastly/3878dad0640be541b88db848f32e5681140534498cd8fada0418e57f4a46867a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2315d0153c0d33cda56fa92f0060dc3a089e46268fffce5d472eabb329a158c1.jpeg",
  ],
  priceDollars: 13.2,
  description:
    "2023 & 2024 Allure Best of Beauty Award Winner\n\nMini size, maximum luxury. Our first-of-its-kind Room Deodorant - now in a perfectly portable size.\n\nClinically tested to reduce and neutralize odors (in the kitchen, bathroom, and beyond) while imparting lasting fine fragrance.\n\nCece\nCedarwood smoke, cardamom, cinnamon, and white leather. Grounded, mysterious, addictive.\n\n𝐍𝐨𝐭𝐞𝐬:\nCardamom*, Mate Leaves*, Cinnamon*, Carrot Seed, Patchouli*, Vetiver*\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐢𝐧𝐠:\n• Zinc Ricinoleate to naturally trap and absorb odor molecules\n• Yeast Ferment to break down odor-causing bacteria\n• Charcoal to purify air\n• Lasting Fine Fragrance to transform your space\n\n𝐃𝐢𝐫𝐞𝐜𝐭𝐢𝐨𝐧𝐬:\nMaking sure to direct nozzle away from face and eyes, spray two or three times into air, at least 8-10 inches from surfaces and walls. Depending on size of room, multiple applications may be necessary.",
  tags: [],
  msrpDollars: 25,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-04-28T15:36:23.770Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
